export const en = {
  // Navigation
  'nav.search.placeholder': 'Search threads, jobs, questions...',
  'nav.anonymous.mode': '[ANONYMOUS_MODE]',
  
  // Sidebar Menu
  'menu.feed': 'Feed',
  'menu.jobs': 'Jobs',
  'menu.study': 'Study',
  'menu.knowledge': 'Knowledge',
  'menu.learning': 'Learning',
  'menu.premium': 'Premium',
  'menu.news': 'News',
  'menu.bugbounty': 'Bug Bounty',
  
  // Feed Tab
  'feed.title': 'Live Feed',
  'feed.new.post': '+ New Post',
  'feed.category.all': 'All',
  'feed.category.vulnerability': 'Vulnerability',
  'feed.category.study': 'Study',
  'feed.category.job': 'Job',
  'feed.category.knowledge': 'Knowledge',
  'feed.replies': 'Replies',
  'feed.likes': 'Likes',
  
  // Jobs Tab
  'jobs.title': 'Job Board',
  'jobs.post.job': '+ Post Job',
  'jobs.salary': 'Salary',
  'jobs.location': 'Location',
  'jobs.experience': 'Experience',
  'jobs.apply.now': '[APPLY NOW]',
  
  // Study Tab
  'study.title': 'Study Q&A',
  'study.ask.question': '+ Ask Question',
  'study.answers': 'Answers',
  'study.views': 'Views',
  'study.solved': '✓ Solved',
  
  // Knowledge Tab
  'knowledge.title': 'Hacker Knowledge',
  'knowledge.subtitle': 'Real-time Hacking Q&A - Bounty System',
  'knowledge.ask.bounty': '+ Ask with Bounty',
  'knowledge.answered': '✓ Answered',
  'knowledge.pending': '⏱ Pending',
  'knowledge.points': 'Points',
  
  // Learning Tab
  'learning.title': 'Learning Sites',
  'learning.subtitle': 'Curated collection of hacking learning platforms',
  'learning.difficulty': 'Difficulty',
  'learning.users': 'Users',
  
  // Premium Tab
  'premium.title': 'Premium Archive',
  'premium.subtitle': 'Real Hacking Trial & Error Archive - Premium Members Only',
  'premium.only': 'Premium Only',
  'premium.exclusive': 'Premium Members Exclusive Content',
  'premium.cases': 'Cases',
  'premium.membership': 'Premium Membership',
  'premium.description': 'Unlimited access to real hacking trial & error archives, expert 1:1 mentoring, premium study groups, and all premium content',
  'premium.price': '$99 / month',
  'premium.upgrade.now': '[UPGRADE NOW]',
  'premium.modal.title': 'Premium Membership Required',
  'premium.modal.description': 'This content is exclusive to premium members. Get access to real hacking trial & error archives and all premium features.',
  'premium.modal.upgrade': '[UPGRADE TO PREMIUM]',
  'premium.modal.close': '[CLOSE]',
  
  // Sidebar Stats
  'stats.title': '// Live Stats',
  'stats.online.hackers': 'Online Hackers',
  'stats.today.posts': 'Today Posts',
  'stats.active.threads': 'Active Threads',
  'stats.trending.tags': '// Trending Tags',
  'stats.top.hackers': '// Top Hackers',
  
  // Time
  'time.minutes.ago': 'min ago',
  'time.hour.ago': 'hour ago',
  'time.hours.ago': 'hours ago',
  'time.realtime': 'Real-time',

  // Search
  'search.input.placeholder': 'Search posts, jobs, questions...',
  'search.tab.all': 'All',
  'search.tab.feed': 'Feed',
  'search.tab.jobs': 'Jobs',
  'search.tab.study': 'Study',
  'search.tab.knowledge': 'Knowledge',
  'search.trending': 'Trending Tags',
  'search.popular': 'Popular Posts',
  'search.results.count': 'results',
  'search.sort.relevance': 'Relevance',
  'search.sort.latest': 'Latest',
  'search.sort.popular': 'Popular',
  'search.no.results': 'No results found',
  'search.no.results.hint': 'Try different keywords',
  'search.just.now': 'Just now',
  'search.type.feed': 'FEED',
  'search.type.job': 'JOB',
  'search.type.study': 'STUDY',
  'search.type.knowledge': 'KNOWLEDGE',

  // Notifications
  'notifications.title': 'Notifications',
  'notifications.all': 'All',
  'notifications.unread': 'Unread',
  'notifications.mark.all.read': 'Mark all as read',
  'notifications.no.unread': 'No unread notifications',
  'notifications.no.notifications': 'No notifications',
  'notifications.new': 'New',
  'notifications.delete': 'Delete',

  // News Tab
  'news.title': 'Hacking News',
  'news.subtitle': 'Hacker News & Community Security News',
  'news.share.news': '+ Share News',
  'news.category.all': 'All',
  'news.category.vulnerability': 'Vulnerability',
  'news.category.breach': 'Data Breach',
  'news.category.malware': 'Malware',
  'news.category.bounty': 'Bug Bounty',
  'news.community': 'Community',
  bugbounty: {
    title: 'Bug Bounty Zone',
    subtitle: 'Explore global bug bounty programs and latest vulnerability reports',
    platforms: {
      title: 'Bug Bounty Platforms',
    },
    writeups: {
      title: 'Recent Public Writeups',
    },
    tips: {
      title: 'Bug Bounty Getting Started Guide',
      start: {
        title: 'Start Small',
        description: 'Begin with low-difficulty programs. Practice finding basic vulnerabilities like XSS, IDOR, CSRF, then gradually expand to more complex ones.',
      },
      tools: {
        title: 'Master Essential Tools',
        description: 'Learn tools like Burp Suite, OWASP ZAP, Nuclei, ffuf, SQLMap. Combining automated tools with manual testing helps discover more vulnerabilities.',
      },
      report: {
        title: 'Write Clear Reports',
        description: 'When you find a vulnerability, clearly document reproduction steps, impact, and PoC. Good reports lead to faster validation and higher rewards.',
      },
      community: {
        title: 'Join the Community',
        description: 'Participate in bug bounty communities on Twitter, Discord, Reddit. Read other hunters\' writeups and learn latest trends and techniques.',
      },
    },
  },
};

export default en;
